var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGridCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 373,
    height: 175,
    viewBox: "0 0 373 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.7462,
    y1: 0.00781248,
    x2: 12.7462,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 28.0108,
    y1: 0.00781248,
    x2: 28.0109,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 43.2765,
    y1: 0.00781248,
    x2: 43.2765,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 58.5421,
    y1: 0.00781248,
    x2: 58.5421,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 73.8067,
    y1: 0.00781248,
    x2: 73.8068,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 89.0724,
    y1: 0.00781248,
    x2: 89.0724,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 104.338,
    y1: 0.00781248,
    x2: 104.338,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 119.603,
    y1: 0.00781248,
    x2: 119.603,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 134.868,
    y1: 0.00781248,
    x2: 134.868,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 150.134,
    y1: 0.00781248,
    x2: 150.134,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 165.399,
    y1: 0.00781248,
    x2: 165.399,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 180.664,
    y1: 0.00781248,
    x2: 180.664,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 195.93,
    y1: 0.00781248,
    x2: 195.93,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 211.194,
    y1: 0.00781248,
    x2: 211.194,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 226.46,
    y1: 0.00781248,
    x2: 226.46,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 241.726,
    y1: 0.00781248,
    x2: 241.726,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 256.99,
    y1: 0.00781248,
    x2: 256.99,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 272.256,
    y1: 0.00781248,
    x2: 272.256,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 287.522,
    y1: 0.00781248,
    x2: 287.522,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 302.786,
    y1: 0.00781248,
    x2: 302.786,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 318.052,
    y1: 0.00781248,
    x2: 318.052,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 333.317,
    y1: 0.00781248,
    x2: 333.318,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 348.583,
    y1: 0.00781248,
    x2: 348.583,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 363.848,
    y1: 0.00781248,
    x2: 363.848,
    y2: 174.032,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 374,
    y1: 3.58897,
    x2: -0.0000305176,
    y2: 3.58897,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 374,
    y1: 18.8546,
    x2: -0.0000305176,
    y2: 18.8546,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 374,
    y1: 34.1202,
    x2: -0.0000305176,
    y2: 34.1202,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 374,
    y1: 49.378,
    x2: -0.0000305176,
    y2: 49.378,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 374,
    y1: 64.6437,
    x2: -0.0000305176,
    y2: 64.6437,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 374,
    y1: 79.9093,
    x2: -0.0000305176,
    y2: 79.9093,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 374,
    y1: 95.1749,
    x2: -0.0000305176,
    y2: 95.1749,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 374,
    y1: 110.441,
    x2: -0.0000305176,
    y2: 110.441,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 374,
    y1: 125.706,
    x2: -0.0000305176,
    y2: 125.706,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 374,
    y1: 140.972,
    x2: -0.0000305176,
    y2: 140.972,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 374,
    y1: 156.237,
    x2: -0.0000305176,
    y2: 156.237,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 374,
    y1: 171.503,
    x2: -0.0000305176,
    y2: 171.503,
    stroke: "#5484F0",
    strokeOpacity: 0.1,
    strokeWidth: 1.06857
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridCard);
export default __webpack_public_path__ + "static/media/GridCard.8e880d7f618083d1d47b80501ea8a3ae.svg";
export { ForwardRef as ReactComponent };